import { render, staticRenderFns } from "./Gather.vue?vue&type=template&id=958cda5e&scoped=true"
import script from "./Gather.vue?vue&type=script&lang=js"
export * from "./Gather.vue?vue&type=script&lang=js"
import style0 from "./Gather.vue?vue&type=style&index=0&id=958cda5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958cda5e",
  null
  
)

export default component.exports